//#region libraries
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';

//redux
import { selectRemovePaxNamePrefix, setRemovePaxNamePrefix } from '_redux/slices/timeline/timeline-control';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

//bootstrap
import { Form } from 'react-bootstrap';

//#endregion
const RemovePaxPrefix = () => {

    const dispatch = useDispatch();
    const removePaxNamePrefix = useSelector(selectRemovePaxNamePrefix);
    const usedTheme = useSelector(selectUsedTheme);


    return (
        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                    Remove name prefix
                </span>
                <Form.Check
                    onClick={() => dispatch(setRemovePaxNamePrefix(!removePaxNamePrefix))}
                    type="switch"
                    defaultChecked={removePaxNamePrefix}
                />
            </div>
            <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                Remove prefix of passenger name (Mr,Miss,Mrs..)
            </span>
        </div>
    );
};


export default RemovePaxPrefix